<template>
  <div>

    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-6">
      <div>
        <div class="flex items-center gap-2 text-sm text-slate-500 mb-1">
          <router-link to="/admin/sistemas" class="hover:text-emerald-600 transition-colors">Sistemas</router-link>
          <i class="fa-solid fa-chevron-right text-xs"></i>
          <router-link to="/admin/planes" class="hover:text-emerald-600 transition-colors">Planes</router-link>
          <i class="fa-solid fa-chevron-right text-xs"></i>
          <span class="text-slate-700 font-medium">Características</span>
          <span v-if="nombrePlan" class="text-emerald-600 font-semibold">· {{ nombrePlan }}</span>
        </div>
        <h2 class="text-2xl font-bold text-slate-800">Características de Planes</h2>
        <p class="text-slate-500 text-sm mt-1">Define las características incluidas o no en cada plan.</p>
      </div>

      <div class="flex flex-wrap gap-3 self-start">
        <select
          v-model="filtroSistema"
          @change="cargarPlanesPorSistema"
          class="border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white"
        >
          <option :value="0">-- Sistema --</option>
          <option v-for="s in sistemas" :key="s.idSistema" :value="s.idSistema">{{ s.icono }} {{ s.nombre }}</option>
        </select>

        <select
          v-model="filtroPlan"
          @change="cargar"
          :disabled="!filtroSistema"
          class="border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white disabled:opacity-50"
        >
          <option :value="0" disabled>-- Selecciona un plan --</option>
          <option v-for="p in planesDelSistema" :key="p.idPlan" :value="p.idPlan">{{ p.nombrePlan }}</option>
        </select>

        <button
          @click="abrirNuevo"
          class="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105"
        >
          <i class="fa-solid fa-plus"></i>
          Nueva Característica
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">#</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Plan</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Característica</th>
              <th class="px-4 py-4 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider">Incluida</th>
              <th class="px-4 py-4 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider">Menú</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Ícono</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Apartado</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Estatus</th>
              <th class="px-4 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100">
            <tr v-if="cargando">
              <td colspan="9" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-spinner fa-spin text-2xl text-emerald-400 mr-2"></i>Cargando...
              </td>
            </tr>
            <tr v-else-if="!filtroSistema || !filtroPlan">
              <td colspan="9" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-arrow-up text-3xl mb-2 block"></i>
                Selecciona un sistema y un plan para ver sus características
              </td>
            </tr>
            <tr v-else-if="caracteristicas.length === 0">
              <td colspan="9" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-inbox text-3xl mb-2 block"></i>No hay características registradas
              </td>
            </tr>
            <tr
              v-else
              v-for="(item, idx) in caracteristicas"
              :key="item.idCaracteristica"
              class="hover:bg-slate-50 transition-colors duration-150"
            >
              <td class="px-4 py-4 text-slate-400 text-xs">{{ idx + 1 }}</td>
              <td class="px-4 py-4">
                <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700">
                  {{ item.nombrePlan }}
                </span>
              </td>
              <td class="px-4 py-4 text-slate-700 max-w-sm">{{ item.descripcion }}</td>
              <td class="px-4 py-4 text-center">
                <span v-if="item.incluida === 'S'" class="text-emerald-500 text-lg">
                  <i class="fa-solid fa-circle-check"></i>
                </span>
                <span v-else class="text-red-400 text-lg">
                  <i class="fa-solid fa-circle-xmark"></i>
                </span>
              </td>
              <td class="px-4 py-4 text-center">
                <span v-if="item.mostrarMenu === 'S'" class="text-blue-500 text-lg" title="Visible en menú">
                  <i class="fa-solid fa-bars-staggered"></i>
                </span>
                <span v-else class="text-slate-300 text-lg" title="No aparece en menú">
                  <i class="fa-solid fa-minus"></i>
                </span>
              </td>
              <td class="px-4 py-4">
                <span v-if="item.iconoMenu" class="text-slate-600 text-base">
                  <i :class="['fa-solid', item.iconoMenu]"></i>
                </span>
                <span v-else class="text-slate-300 text-xs">—</span>
              </td>
              <td class="px-4 py-4">
                <span v-if="item.nomApartado" class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700">
                  {{ item.nomApartado }}
                </span>
                <span v-else class="text-slate-300 text-xs">—</span>
              </td>
              <td class="px-4 py-4">
                <span :class="['inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold',
                               item.estatus === 'A' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600']">
                  <span :class="['w-1.5 h-1.5 rounded-full', item.estatus === 'A' ? 'bg-emerald-500' : 'bg-red-500']"></span>
                  {{ item.estatus === 'A' ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td class="px-4 py-4">
                <div class="flex items-center gap-2">
                  <button @click="editar(item)"
                    class="p-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors duration-150" title="Editar">
                    <i class="fa-solid fa-pen-to-square text-xs"></i>
                  </button>
                  <button @click="cambiarEstatus(item)"
                    :class="['p-2 rounded-lg transition-colors duration-150',
                             item.estatus === 'A' ? 'bg-red-50 hover:bg-red-100 text-red-500' : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600']"
                    :title="item.estatus === 'A' ? 'Desactivar' : 'Activar'">
                    <i :class="['text-xs', item.estatus === 'A' ? 'fa-solid fa-ban' : 'fa-solid fa-check']"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ─────── MODAL ─────── -->
    <transition name="modal">
      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center modal-overlay p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-y-auto">

          <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 sticky top-0 bg-white z-10">
            <h3 class="font-bold text-slate-800 text-lg">
              <i class="fa-solid fa-list-check text-emerald-500 mr-2"></i>
              {{ modoEdicion ? 'Editar Característica' : 'Nueva Característica' }}
            </h3>
            <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 p-1">
              <i class="fa-solid fa-xmark text-lg"></i>
            </button>
          </div>

          <div class="px-6 py-5 space-y-4">

            <!-- Sistema -->
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Sistema <span class="text-red-500">*</span></label>
              <select
                v-model="filtroSistema"
                @change="alCambiarSistemaEnModal"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white"
              >
                <option :value="0" disabled>-- Selecciona un sistema --</option>
                <option v-for="s in sistemas" :key="s.idSistema" :value="s.idSistema">{{ s.icono }} {{ s.nombre }}</option>
              </select>
            </div>

            <!-- Plan -->
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Plan <span class="text-red-500">*</span></label>
              <select
                v-model="form.idPlan"
                :disabled="!filtroSistema"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 bg-white disabled:opacity-50"
              >
                <option :value="0" disabled>-- Selecciona un plan --</option>
                <option v-for="p in planesDelSistema" :key="p.idPlan" :value="p.idPlan">{{ p.nombrePlan }}</option>
              </select>
            </div>

            <!-- Descripción -->
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Descripción <span class="text-red-500">*</span></label>
              <input
                v-model="form.descripcion"
                type="text"
                maxlength="500"
                placeholder="Ej. Hasta 500 productos en catálogo"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
            </div>

            <!-- Descripción del menú (solo si mostrarMenu = S) -->
            <div v-if="form.mostrarMenu === 'S'">
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                <i class="fa-solid fa-tag text-emerald-400 mr-1"></i>
                Descripción en menú
              </label>
              <input
                v-model="form.descMenu"
                type="text"
                maxlength="200"
                placeholder="Ej. Consulta básica (texto que aparece en el menú)"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
              <p class="text-xs text-slate-400 mt-1">Si se deja vacío se usará la Descripción como nombre en el menú.</p>
            </div>

            <!-- Orden en menú (solo si mostrarMenu = S) -->
            <div v-if="form.mostrarMenu === 'S'">
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                <i class="fa-solid fa-sort text-indigo-400 mr-1"></i>
                Orden en el menú
              </label>
              <input
                v-model.number="form.orden"
                type="number"
                min="0"
                max="9999"
                placeholder="0"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent transition-all"
              />
              <p class="text-xs text-slate-400 mt-1">Número menor aparece primero. 0 = al final.</p>
            </div>

            <!-- Incluida -->
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">¿Característica incluida?</label>
              <div class="flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" v-model="form.incluida" value="S" class="accent-emerald-500" />
                  <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all"
                    :class="form.incluida === 'S' ? 'bg-emerald-50 border-emerald-300 text-emerald-700' : 'border-slate-200 text-slate-500'">
                    <i class="fa-solid fa-check text-xs"></i> Sí, incluida
                  </span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" v-model="form.incluida" value="N" class="accent-red-400" />
                  <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all"
                    :class="form.incluida === 'N' ? 'bg-red-50 border-red-300 text-red-600' : 'border-slate-200 text-slate-500'">
                    <i class="fa-solid fa-xmark text-xs"></i> No incluida
                  </span>
                </label>
              </div>
            </div>

            <!-- Mostrar en menú -->
            <div class="border border-slate-200 rounded-xl p-4 bg-slate-50">
              <label class="block text-sm font-semibold text-slate-700 mb-2">
                <i class="fa-solid fa-bars-staggered text-blue-400 mr-1"></i>
                Mostrar en menú
              </label>
              <div class="flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" v-model="form.mostrarMenu" value="S" class="accent-blue-500" />
                  <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all"
                    :class="form.mostrarMenu === 'S' ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-slate-200 text-slate-500'">
                    <i class="fa-solid fa-eye text-xs"></i> Sí
                  </span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" v-model="form.mostrarMenu" value="N" class="accent-slate-400" />
                  <span class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border transition-all"
                    :class="form.mostrarMenu === 'N' ? 'bg-slate-100 border-slate-400 text-slate-600' : 'border-slate-200 text-slate-500'">
                    <i class="fa-solid fa-eye-slash text-xs"></i> No
                  </span>
                </label>
              </div>
            </div>

            <!-- Ícono menú (solo si mostrarMenu = S) -->
            <div v-if="form.mostrarMenu === 'S'">
              <label class="block text-sm font-semibold text-slate-700 mb-2">
                <i class="fa-solid fa-icons text-purple-400 mr-1"></i>
                Ícono del menú
              </label>
              <div class="flex items-center gap-3 mb-3">
                <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow flex-shrink-0">
                  <i :class="['fa-solid', form.iconoMenu || 'fa-star', 'text-white text-sm']"></i>
                </div>
                <input
                  v-model="form.iconoMenu"
                  type="text"
                  placeholder="fa-star"
                  class="flex-1 border border-slate-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 font-mono"
                />
              </div>
              <div class="border border-slate-200 rounded-xl p-3 bg-white">
                <p class="text-xs text-slate-400 mb-2">Selecciona un ícono:</p>
                <div class="grid grid-cols-10 gap-1 max-h-40 overflow-y-auto">
                  <button
                    v-for="ic in iconosCatalogo"
                    :key="ic"
                    type="button"
                    @click="form.iconoMenu = ic"
                    :title="ic"
                    :class="['w-8 h-8 rounded-lg flex items-center justify-center text-sm transition-all duration-150',
                             form.iconoMenu === ic
                               ? 'bg-indigo-600 text-white shadow-md scale-110'
                               : 'bg-slate-50 hover:bg-indigo-50 text-slate-600 hover:text-indigo-600']"
                  >
                    <i :class="['fa-solid', ic]"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Apartado del menú (solo si mostrarMenu = S) -->
            <div v-if="form.mostrarMenu === 'S'">
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                <i class="fa-solid fa-layer-group text-indigo-400 mr-1"></i>
                Apartado del menú
              </label>
              <select
                v-model="form.idApartado"
                :disabled="!filtroSistema"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-400 bg-white disabled:opacity-50"
              >
                <option :value="0">-- Sin apartado --</option>
                <option v-for="a in apartadosMenu" :key="a.idApartadoMenu" :value="a.idApartadoMenu">
                  {{ a.nomApartado }}
                </option>
              </select>
              <p v-if="!filtroSistema" class="text-xs text-slate-400 mt-1">Selecciona un sistema para ver los apartados.</p>
            </div>

          </div>

          <div class="flex justify-end gap-3 px-6 py-4 border-t border-slate-100 sticky bottom-0 bg-white">
            <button @click="cerrarModal"
              class="px-5 py-2.5 rounded-xl border border-slate-300 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all">
              Cancelar
            </button>
            <button @click="guardar" :disabled="guardando"
              class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed">
              <i v-if="guardando" class="fa-solid fa-spinner fa-spin mr-1"></i>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>

        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import servicioCarac     from '@/services/caracteristicasplan.service'
import servicioPlan      from '@/services/planes.service'
import servicioSistema   from '@/services/sistemas.service'
import servicioApartados from '@/services/apartadosmenu.service'

export default {
  name: 'CaracteristicasPlanAdmin',

  props: {
    idPlan: { default: null }
  },

  data () {
    return {
      caracteristicas:  [],
      sistemas:         [],
      planes:           [],
      planesDelSistema: [],
      apartadosMenu:    [],
      filtroSistema:    0,
      filtroPlan:       0,
      nombrePlan:       '',
      cargando:         false,
      guardando:        false,
      modalVisible:     false,
      modoEdicion:      false,

      form: {
        idCaracteristica: 0,
        idPlan:           0,
        descripcion:      '',
        descMenu:         '',
        orden:            0,
        incluida:         'S',
        mostrarMenu:      'N',
        iconoMenu:        '',
        idApartado:       0
      },

      iconosCatalogo: [
        'fa-house', 'fa-users', 'fa-user', 'fa-calendar', 'fa-calendar-days',
        'fa-chart-bar', 'fa-chart-line', 'fa-chart-pie', 'fa-table', 'fa-list',
        'fa-database', 'fa-server', 'fa-cloud', 'fa-code', 'fa-terminal',
        'fa-file', 'fa-file-text', 'fa-folder', 'fa-folder-open', 'fa-inbox',
        'fa-envelope', 'fa-bell', 'fa-star', 'fa-heart', 'fa-bookmark',
        'fa-tag', 'fa-tags', 'fa-box', 'fa-boxes-stacked', 'fa-cart-shopping',
        'fa-credit-card', 'fa-money-bill', 'fa-coins', 'fa-receipt', 'fa-wallet',
        'fa-phone', 'fa-mobile', 'fa-desktop', 'fa-laptop', 'fa-print',
        'fa-camera', 'fa-image', 'fa-video', 'fa-music', 'fa-microphone',
        'fa-shield', 'fa-lock', 'fa-key', 'fa-eye', 'fa-search',
        'fa-cog', 'fa-gear', 'fa-wrench', 'fa-hammer', 'fa-tools',
        'fa-map', 'fa-globe', 'fa-location-dot', 'fa-building', 'fa-store',
        'fa-graduation-cap', 'fa-book', 'fa-pen', 'fa-pencil', 'fa-palette',
        'fa-stethoscope', 'fa-pills', 'fa-tooth', 'fa-hospital', 'fa-microscope',
        'fa-robot', 'fa-brain', 'fa-lightbulb', 'fa-fire', 'fa-bolt',
        'fa-gem', 'fa-crown', 'fa-trophy', 'fa-medal', 'fa-flag',
        'fa-link', 'fa-paperclip', 'fa-grip', 'fa-layer-group', 'fa-sitemap',
        'fa-bars', 'fa-ellipsis', 'fa-sliders', 'fa-filter', 'fa-sort',
        'fa-leaf', 'fa-seedling', 'fa-sun', 'fa-moon', 'fa-snowflake',
        'fa-car', 'fa-truck', 'fa-plane', 'fa-ship', 'fa-rocket'
      ]
    }
  },

  mounted () {
    if (this.idPlan) this.filtroPlan = parseInt(this.idPlan)
    this.cargarSistemas()
    if (this.idPlan) this.cargar()
  },

  methods: {
    async cargarSistemas () {
      try {
        const res = await servicioSistema.sistemasCon()
        this.sistemas = (res.data.sistemas || []).filter(s => s.estatus === 'A')

        if (this.filtroPlan) {
          const resP = await servicioPlan.planesCon(0)
          const plan = (resP.data.planes || []).find(p => p.idPlan === this.filtroPlan)
          if (plan) {
            this.filtroSistema = plan.idSistema
            this.nombrePlan    = plan.nombrePlan
            await this.cargarPlanesPorSistema()
            await this.cargarApartados(plan.idSistema)
          }
        }
      } catch { /* silencioso */ }
    },

    async cargarPlanesPorSistema () {
      this.filtroPlan       = 0
      this.planesDelSistema = []
      this.caracteristicas  = []
      if (!this.filtroSistema) return
      try {
        const res = await servicioPlan.planesCon(this.filtroSistema)
        this.planesDelSistema = res.data.planes || []
      } catch (err) {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cargar los planes: ' + (err.message || ''), tipo: 'error' })
      }
    },

    async cargarApartados (idSistema) {
      try {
        const res = await servicioApartados.apartadosMenuCon(idSistema || 0)
        this.apartadosMenu = res.data.apartadosMenu || []
      } catch { this.apartadosMenu = [] }
    },

    async alCambiarSistemaEnModal () {
      this.form.idApartado = 0
      await this.cargarPlanesPorSistema()
      if (this.filtroSistema) await this.cargarApartados(this.filtroSistema)
    },

    async cargar () {
      if (!this.filtroPlan) { this.caracteristicas = []; return }
      this.cargando = true
      try {
        const res = await servicioCarac.caracteristicasCon(this.filtroPlan)
        this.caracteristicas = res.data.caracteristicasPlan || []
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cargar características', tipo: 'error' })
      } finally {
        this.cargando = false
      }
    },

    abrirNuevo () {
      this.modoEdicion = false
      this.form = {
        idCaracteristica: 0,
        idPlan:           this.filtroPlan || 0,
        descripcion:      '',
        descMenu:         '',
        orden:            0,
        incluida:         'S',
        mostrarMenu:      'N',
        iconoMenu:        '',
        idApartado:       0
      }
      if (this.filtroSistema) this.cargarApartados(this.filtroSistema)
      this.modalVisible = true
    },

    editar (item) {
      this.modoEdicion = true
      this.form = {
        idCaracteristica: item.idCaracteristica,
        idPlan:           item.idPlan,
        descripcion:      item.descripcion,
        descMenu:         item.descMenu    || '',
        orden:            item.orden       || 0,
        incluida:         item.incluida,
        mostrarMenu:      item.mostrarMenu || 'N',
        iconoMenu:        item.iconoMenu   || '',
        idApartado:       item.idApartado  || 0
      }

      const plan = this.planesDelSistema.find(p => p.idPlan === item.idPlan)
      if (!plan) {
        servicioPlan.planesCon(0).then(async res => {
          const p2 = (res.data.planes || []).find(p => p.idPlan === item.idPlan)
          if (p2) {
            this.filtroSistema = p2.idSistema
            await this.cargarPlanesPorSistema()
            this.form.idPlan = item.idPlan
            await this.cargarApartados(p2.idSistema)
          }
        }).catch(() => {})
      } else if (this.filtroSistema) {
        this.cargarApartados(this.filtroSistema)
      }

      this.modalVisible = true
    },

    cerrarModal () { this.modalVisible = false },

    async guardar () {
      if (!this.form.descripcion.trim() || !this.form.idPlan) {
        this.$store.dispatch('mostrarToast', { mensaje: 'El plan y la descripción son obligatorios', tipo: 'warning' })
        return
      }
      this.guardando = true
      try {
        const res = await servicioCarac.guardar(this.form)
        if (res.data.resultado) {
          this.cerrarModal()
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        } else {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al guardar la característica', tipo: 'error' })
      } finally {
        this.guardando = false
      }
    },

    async cambiarEstatus (item) {
      const nuevoEstatus = item.estatus === 'A' ? 'I' : 'A'
      try {
        const res = await servicioCarac.cambiarEstatus({ idCaracteristica: item.idCaracteristica, estatus: nuevoEstatus })
        if (res.data.resultado) {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cambiar estatus', tipo: 'error' })
      }
    }
  }
}
</script>
